import Angular from "angular";
import Template from "./wheel-storage-type-icon.html";

export default Angular.module('wheel-storage-type-icon', [])
    .component('wheelStorageTypeIcon', {
        template: Template,
        bindings: {
            storageType: '<',
            withLabel: '@'
        },
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/wheel-storage-type-icon/wheel-storage-type-icon.js